import React from "react"
import { AlertTriangle as Icon } from "react-feather"

import style from "./Maintenance.module.scss"
import { brand } from "../../consts/brand"

export const Maintenance: React.FunctionComponent = () => {
  return (
    <div className={`${style.maintenancePage}`} id="maintenance">
      <div className={style.icon}>
        <Icon aria-hidden="true" />
      </div>
      {/* Keep the pre-merger name until the post-merger update. */}
      <h1 className={style.title}>Banca CF+ è in manutenzione</h1>
      <p className={style.text}>L&apos;applicazione non è disponibile al momento, tornerà online a breve</p>
      <a href={`${brand.websiteUrl}/contatti/`} className={style.cta}>
        Contattaci
      </a>
    </div>
  )
}
